import { Injectable } from '@angular/core';
import { LocalStorageService } from "../../services/storage/localstorage.service";
import { BodyClassTogglerService } from "../../services/interface/body-class-toggler.service";

const key='dark-mode'

@Injectable({
   providedIn: 'root'
})
export class DarkModeService {
   private darkMode: boolean=false

   constructor(
      private LocalStorageService: LocalStorageService,
      private BodyClassTogglerService: BodyClassTogglerService
   ) { }
   check(defaultDarkMode: boolean=false) {
      if(!this.checkLocalStorage()) {
         this.darkMode=defaultDarkMode
         this.setLocalStorage()
      } else 
         this.darkMode=this.getLocalStorage()
      this.setBodyClass()
   }
   set(darkMode: boolean) {
      this.darkMode=darkMode
      this.setLocalStorage()
      this.setBodyClass()
   }
   get(defaultDarkMode: boolean=false): boolean {
      if(!this.checkLocalStorage()) 
         return defaultDarkMode
      else 
         return this.getLocalStorage()
   }
   private checkLocalStorage(): boolean {
      return this.LocalStorageService.hasKey(key)
   }
   private getLocalStorage(): boolean {
      return this.LocalStorageService.get(key)
   }
   private setLocalStorage() {
      this.LocalStorageService.set(key, this.darkMode);
   }
   private setBodyClass() {
      if (this.darkMode)
         this.BodyClassTogglerService.checkClass(key);
      else
         this.BodyClassTogglerService.removeClass(key);
   }
}
